<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Icon from './components/Icon.vue';
import { useVisualViewport } from './composables/useVisualViewport.ts';
import { useSessionStore } from './stores/session.ts';

useVisualViewport();

const route = useRoute();
const session = useSessionStore();

const signedIn = computed(() => route.name !== 'login');

const TABS = [
  { to: '/learn', icon: 'learn', label: 'Учить' },
  { to: '/progress', icon: 'progress', label: 'Прогресс' },
  { to: '/sources', icon: 'sources', label: 'Источники' },
  { to: '/settings', icon: 'settings', label: 'Настройки' },
] as const;

const section = computed(() => `/${route.path.split('/')[1] ?? ''}`);

const CARD_PHASES: readonly string[] = ['intro', 'prompt', 'result'];

const showTabs = computed(() => {
  if (!signedIn.value) return false;
  if (route.name !== 'learn') return true;
  return !CARD_PHASES.includes(session.phase);
});
</script>

<template>
  <div class="shell">
    <aside v-if="signedIn" class="shell__rail">
      <div class="shell__brand"><i />Vocab</div>
      <nav class="rail-nav">
        <RouterLink
          v-for="tab in TABS"
          :key="tab.to"
          :to="tab.to"
          :class="{ 'nav--on': section === tab.to }"
          :aria-current="section === tab.to ? 'page' : undefined"
          >{{ tab.label }}</RouterLink
        >
      </nav>
      <div class="rail-facts">
        <div>очередь · {{ session.remaining }}</div>
        <div v-if="session.lists.length">список · {{ session.listTitle }}</div>
      </div>
    </aside>

    <div class="shell__main">
      <RouterView />

      <nav v-if="showTabs" class="tabbar">
        <RouterLink
          v-for="tab in TABS"
          :key="tab.to"
          :to="tab.to"
          :class="{ 'nav--on': section === tab.to }"
          :aria-current="section === tab.to ? 'page' : undefined"
        >
          <Icon :name="tab.icon" />{{ tab.label }}
        </RouterLink>
      </nav>
    </div>
  </div>
</template>
